import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import StandardButton from "@/components/buttons/StandardButton.vue";
let AlertDialog = class AlertDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "message", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "closeOnOutsideClick", void 0);
    _defineProperty(this, "isVisible", false);
  }
  mounted() {
    this.isVisible = this.visible;
  }
  onVisiblePropChanges() {
    this.isVisible = this.visible;
  }
  handleDialogClose() {
    this.isVisible = false;
    return true;
  }
};
__decorate([Prop({
  default: ''
})], AlertDialog.prototype, "title", void 0);
__decorate([Prop({
  default: ''
})], AlertDialog.prototype, "message", void 0);
__decorate([Prop({
  default: '560px'
})], AlertDialog.prototype, "width", void 0);
__decorate([Prop({
  default: false
})], AlertDialog.prototype, "visible", void 0);
__decorate([Prop({
  default: true
})], AlertDialog.prototype, "closeOnOutsideClick", void 0);
__decorate([Watch('visible')], AlertDialog.prototype, "onVisiblePropChanges", null);
__decorate([Emit("on-dialog-close")], AlertDialog.prototype, "handleDialogClose", null);
AlertDialog = __decorate([Component({
  components: {
    StandardButton
  },
  emits: ['on-dialog-close']
})], AlertDialog);
export default AlertDialog;